<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <div class="zixun">
      <div class="top">
        <div class="left" v-if="type==='modal'">
          <div>下载申请</div>
          <div>请留下您的联系方式，我们将尽快与您联系</div>
        </div>
        <div class="left" v-else>
          <div>立即咨询</div>
          <div>请留下您的联系方式与问题，我们将尽快与您联系，或直接发送至<span>sales@corepilot-semi.com</span></div>
        </div>
        <div v-if="$store.state.sizeType == 'pc'" class="btn" @click="submit()">提交 <img
            src="../assets/home/arrow-right-line.png">
        </div>
      </div>

      <div class="form">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <div class="line">
            <FormItem label="姓名：" prop="userName">
              <Input v-model="formValidate.userName" placeholder="请输入您的姓名"></Input>
            </FormItem>
            <FormItem label="公司：" prop="companyName">
              <Input v-model="formValidate.companyName" placeholder="请输入您的公司名称"></Input>
            </FormItem>
          </div>

          <div class="line">
            <FormItem label="职位：" prop="position">
              <Input v-model="formValidate.position" placeholder="请输入您的职位"></Input>
            </FormItem>
            <FormItem label="企业邮箱：" prop="email">
              <Input v-model="formValidate.email" placeholder="请输入您的企业邮箱"></Input>
            </FormItem>
          </div>

          <div class="line">
            <FormItem label="手机号码：" prop="telNo">
              <Input v-model="formValidate.telNo" placeholder="请输入您的手机号码"></Input>
            </FormItem>
            <FormItem v-if="type==='modal'" label="下载事由：" prop="content">
              <Input v-model="formValidate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                placeholder="请您告知下载这份资料的原因，以帮我们更好地了解您的需求和提供服务，谢谢！"></Input>
            </FormItem>
            <FormItem v-else label="问题咨询：" prop="content">
              <Input v-model="formValidate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                placeholder="请输入您要咨询的问题"></Input>
            </FormItem>
            <!-- <FormItem label="验证码：" prop="name">
              <Input on-search="" v-model="formValidate.name" placeholder="请输入收到的验证码" search
                enter-button="获取验证码"></Input>
            </FormItem> -->
          </div>

          <!-- <div class="line">
            <FormItem label="问题咨询：" prop="content">
              <Input v-model="formValidate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                placeholder="请输入您要咨询的问题"></Input>
            </FormItem>
          </div> -->

        </Form>

        <div v-if="$store.state.sizeType == 'phone'" class="btn" @click="submit()">提交 <img
            src="../assets/home/arrow-right-line.png">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'form2',
  inject: ['reload'],
  props: ["name", "key2", "type"],
  data() {
    return {
      formValidate: {},
      ruleValidate: {
        userName: [
          { required: true, message: '该选项为必填项', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '该选项为必填项', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '该选项为必填项', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '该选项为必填项', trigger: 'blur' }
        ],
        telNo: [
          { required: true, message: '该选项为必填项', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '该选项为必填项', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur'
          }
        ]
      },
    };
  },
  methods: {
    submit() {
      const forbiddenDomains = [
        'qq.com',
        '163.com',
        '126.com'
      ]
      const domain = this.formValidate.email.split('@')[1].toLowerCase()
      if (forbiddenDomains.includes(domain)) {
        this.$Message.error('不支持 QQ / 163 / 126 邮箱')
        return
      }
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          // ✅ 校验通过，提交接口
          this.$config('/open/api/email/send', { ...this.formValidate, productId: this.key2, fileName: this.name }).then(res => {
            this.formValidate = {};
            if(this.type==='modal'){
              this.$Modal.confirm({
                title: '提示',
                content: '感谢垂询，我们将尽快审核您的信息，通过后将把资料发送到您提供的邮箱。谢谢！',
              })
              // this.$Message.success('感谢垂询，我们将尽快审核您的信息，通过后将把资料发送到您提供的邮箱。谢谢！')
            } else {
              this.$Message.success('操作成功')
            }
            this.$emit('close');
          }).catch(err => { })
        } else {
          // ❌ 校验失败
        }
      })
    },
  },
  mounted() {
    
  }
};
</script>

<style scoped lang='scss'>
  .zixun {
    padding: 0.95rem calc(50% - 600px);

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 24px;
        color: #000000;

        div:last-child {
          // font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          margin-top: 0.3rem;

          span {
            color: #004CFA;
          }
        }
      }

      .btn {
        width: 2.22rem;
        height: 0.79rem;
        background: #00B4A9;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.25rem;
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 0.24rem;
        color: #FFFFFF;
        cursor: pointer;

        img {
          width: 0.28rem;
          height: 0.28rem;
        }
      }
    }

    form {
      padding: 0.8rem 0;

      .line {
        display: flex;
        justify-content: space-between;

        &>div {
          width: calc(50% - 0.2rem);
        }

        &>>>.ivu-form-item {
          width: calc(50% - 0.2rem);

          .ivu-form-item-label {
            font-size: 0.24rem;
            color: #333333;
            // font-family: Source Han Sans CN, Source Han Sans CN;
            margin-bottom: 0.12rem;
          }

          input {
            height: 0.64rem;
            font-size: 0.24rem;
            padding-left: 0.15rem;
          }

          textarea {
            font-size: 0.24rem;
            padding-left: 0.15rem;
          }

          .ivu-form-item-error-tip {
            font-size: 0.24rem;
            padding-top: 0.15rem;
          }

          .ivu-input-search {
            font-size: 0.24rem;
            background-color: #00B4A9 !important;
            border: none;
            width: 1.96rem;
          }

          .ivu-form-item-error-tip{
            font-size: 0.14rem;
            padding-top: 0.08rem;
          }
        }



        // &:last-child {
        //   & > div {
        //     width: 100%;
        //   }
        //   &>>>.ivu-form-item {
        //     width: 100%;
        //   }
        // }
      }
    }
  }

  @media screen and (max-width: 750px){
    .zixun {
      padding: 0.95rem 0.6rem;

      .top {
        .left {
          font-weight: 500;
          font-size: 0.32rem;

          div:last-child {
            font-size: 0.24rem;
            line-height: 0.58rem;
            padding-right: .7rem;
          }
        }
      }

      .form {
        form {
          .line {
            display: block;

            &>div {
              width: 100%;
            }

            &>>>.ivu-form-item {
              width: 100%;

              .ivu-form-item-error-tip{
                font-size: 0.18rem;
              }
            }

            &:last-child {
              &>div:last-child {
                margin-bottom: 0;
              }
            }
          }


        }

        .btn {
          width: 100%;
          height: .79rem;
          background: #00B4A9;
          border-radius: 4px 4px 4px 4px;
          // font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 0.24rem;
          color: #FFFFFF;
          line-height: .79rem;
          text-align: center;
        }
      }

      .pdf {
        padding-top: .9rem;

        .one {
          width: 100%;
          height: 2.06rem;
          padding-left: .3rem;

          .right {
            .top {
              font-size: 0.24rem;
              width: calc(100% - 0.8rem);
              word-break: break-all;
            }

            .bottom {
              font-size: 0.18rem;
              margin-top: .25rem;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/form2.vue